import React, { useEffect } from 'react';
import axios from 'src/utils/axios';
import moment from 'moment';
import { Card, Container, Box, Backdrop, CircularProgress, Grid, createTheme, Divider, CardContent, CardHeader, IconButton, Autocomplete, TextField, Button, Stack, Checkbox, MenuItem, Alert, Snackbar } from "@mui/material";
import { makeStyles } from '@material-ui/styles';
import { DataGrid, GridToolbarContainer, GridToolbarExport, trTR } from '@mui/x-data-grid';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import trLocale from 'date-fns/locale/tr';
import { Bar } from 'react-chartjs-2';
import Page from 'src/components/Page';
import AlertComponent from 'src/components/Alert';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  backdrop: {
    zIndex: 2000,
    color: '#fff'
  }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const smsStatusOptions = [
  { label: 'Tümü', value: 0 },
  { label: 'Başarılı', value: 3 },
  { label: 'Başarısız', value: 4 }
]

function SmsTrackingReport({ onClick }) {

  const classes = useStyles();
  const [sendSuccesData, setSendSuccesData] = React.useState([]);
  const [smsGeneralData, setSmsGeneralData] = React.useState([]);
  const [EkgarantiData, setEkGarantiData] = React.useState(0);
  const [FisBaslandi, setFisBaslandi] = React.useState(0);
  const [FarklıMarkaSayı, setFarklıMarkaSayı] = React.useState(0);
  const [MusteriTalebiİptal, setMusteriTalepIptal] = React.useState(0);
  const [MalzemeTeminiYokSayi, setMalzemeTeminYokSayi] = React.useState(0);
  const [MusteriUcretıKabulEtmiyorSayi, setMusteriUcretiKabulEtmiyorSayi] = React.useState(0);
  const [MemnuniyetGarantisiArtemisSayi, setMemnuniyetGarantisiArtemisSayi] = React.useState(0);
  const [MusteriyeGidilemiyorSayi, setMusteriyeGidilemiyorSayi] = React.useState(0);
  const [loadingx, setLoadingx] = React.useState(false);

  const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = React.useState(
    new Date()
  );

  const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = React.useState(
    new Date()
  );
  const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY')
  const formattedBitisDate = moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY')
  const [smsSablonBasliklar, setSmsSablonBasliklar] = React.useState([]);
  const [selectedSmsSablonBasliklar, setSelectedSmsSablonBasliklar] = React.useState([]);
  const [smsMarkalar, setSmsMarkalar] = React.useState([]);
  const [selectedMarkalar, setSelectedMarkalar] = React.useState([]);
  const [smsKullanicilar, setSmsKullanicilar] = React.useState([]);
  const [selectedSmsKullanicilar, setSelectedSmsKullanicilar] = React.useState([]);
  const [smsGonderimDurumlar, setSmsGonderimDurumlar] = React.useState([]);
  const [selectedSmsGonderimDurumlar, setSelectedSmsGonderimDurumlar] = React.useState([]);
  const [Warning, setWarning] = React.useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const [responseMessage, setresponseMessage] = React.useState("");

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Chart.js Bar Chart',
      },
    },
  };
  //Düzeltilecek. Dinamik şekilde çekilecek.
  const labels = ['Fiş Başlandı', 'Ys Ekgaranti', 'Müşteri Talebi İptal Ettirdi', 'Müşteri Ürün Farklı Marka', 'Demode Malzeme Temini Yok', 'Müşteri Ücreti Kabul Etmiyor', 'Mücbir Sebep ile Gidilemiyor', 'Memnuniyet Ek Garanti Artemis'];
  //9-39-40-43-41-42-44-55

  const backgroundColors = [
    'rgba(255, 99, 132, 0.5)',
    'rgba(54, 162, 235, 0.5)',
    'rgba(255, 206, 86, 0.5)',
    'rgba(75, 192, 192, 0.5)',
    'rgba(41, 192, 192, 0.5)',
    'rgba(41, 42, 192, 0.5)',
    'rgba(41, 42, 44, 0.5)',
    'rgba(55, 255, 44, 0.5)',
  ];

  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [FisBaslandi, EkgarantiData, MusteriTalebiİptal, FarklıMarkaSayı, MalzemeTeminiYokSayi, MusteriUcretıKabulEtmiyorSayi, MusteriyeGidilemiyorSayi, MemnuniyetGarantisiArtemisSayi], // Statik veriler
        //data: [500, 1233, 399, 224, 899, 600, 234, 109, 396],
        backgroundColor: backgroundColors
      }
    ],
  };

  const handleExportClick = (buttonType) => {
    var exportData = [];
    if (buttonType === 1) {
      smsGeneralData.map((item) => {
        exportData.push({
          'Fiş Numarası': item.FIS_NO,
          'Cep Telefonu': item.CEP_TEL,
          'Sms Şablon Başlığı': item.BASLIK,
          'Sms İçeriği': item.MESAJ,
          'Kullanıcı Adı': item.KULLANICI_ADI,
          'Gonderim Tarihi': moment(item.GONDERIM_TARIHI).format('DD-MM-YYYY h:mm:ss'),
        })
      })
      ExcelFileCreator(exportData, `Sms Şablon Takip Raporu`);
    }
  };

  const columns = [
    {
      field: 'ID',
      headerName: 'Id',
      width: 100,
    },
    {
      field: 'FIS_NO',
      headerName: 'Fiş Numarası',
      width: 150,
    },
    {
      field: 'CEP_TEL',
      headerName: 'Cep Telefonu',
      width: 110,
      renderCell: (cellValues) => {
        const cepTel = cellValues.row.CEP_TEL;
        // Maskelemek için  üç karakteri (*) ile değiştir
        const maskedCepTel = cepTel ? cepTel.substring(0, 3) + '****' + cepTel.substring(7) : '-';
        return maskedCepTel;
      },
    },
    {
      field: 'BASLIK',
      headerName: 'Sms Şablon Başlığı',
      width: 400,
    },
    {
      field: 'MESAJ',
      headerName: 'Sms İçeriği',
      width: 600,
    },
    {
      field: 'MARKA',
      headerName: 'Marka',
      width: 110,
    },
    {
      field: 'KULLANICI_ADI',
      headerName: 'Kullanıcı Adı',
      width: 110,
    },
    {
      field: 'DURUM_ACIKLAMA',
      headerName: 'Durum',
      width: 150,
    },
    {
      field: 'GONDERIM_TARIHI',
      headerName: 'Gönderilme Tarihi',
      width: 150,
      renderCell: (cellValues) => {
        return (
          cellValues.row.GONDERIM_TARIHI ? moment(cellValues.row.GONDERIM_TARIHI).format('DD-MM-YYYY, HH:mm:ss') : '-'
        );
      },
    },
  ];

  function QuickSearchToolbar(props) {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <Grid container spacing={2} >
          <Grid item xs={4} md={4}>
            <GridToolbarContainer >
              <GridToolbarExport
                sx={{ color: '#FF9800' }}
                csvOptions={{
                  utf8WithBom: true,
                }} />
            </GridToolbarContainer>
          </Grid>
        </Grid>
      </Box>
    );
  }



  useEffect(() => {
    getSmsGonderilenSmsler();
    getSmsSablonBasliklar();
    getSmsMarkalar();
    getSmsKullanicilar();
  }, []);

  const getSmsGonderilenSmsler = () => {
    setLoadingx(true)
    axios.get("/GetSmsGonderilenSmsler").then((response) => {
      var successData = [];
      var errorData = [];
      if (response.data.length > 0) {
        response.data.map((i) => {
          if (i.DURUM === 3) {
            successData.push(i);//Gönderilen smsler
          }
          else {
            errorData.push(i);//Gönderilemeyen smsler
          }
        });
        setSmsGeneralData(response.data);
        GrafikDataDoldur(successData);
        setLoadingx(false);
      }
    })
    setLoadingx(false)
  }

  function GrafikDataDoldur(successData) {
    var ekgaranti = successData.filter(i => i.MESAJ_SABLON_ID === 9).length
    setEkGarantiData(ekgaranti)
    var baslandi = successData.filter(i => i.MESAJ_SABLON_ID === 39).length
    setFisBaslandi(baslandi)
    var FarklıMarka = successData.filter(i => i.MESAJ_SABLON_ID === 43).length
    setFarklıMarkaSayı(FarklıMarka)
    var Musteriİptali = successData.filter(i => i.MESAJ_SABLON_ID === 40).length
    setMusteriTalepIptal(Musteriİptali)
    var MalzemeTeminiYok = successData.filter(i => i.MESAJ_SABLON_ID === 41).length
    setMalzemeTeminYokSayi(MalzemeTeminiYok)
    var MusteriUcretıKabulEtmiyor = successData.filter(i => i.MESAJ_SABLON_ID === 42).length
    setMusteriUcretiKabulEtmiyorSayi(MusteriUcretıKabulEtmiyor)
    var MusteriyeGidilemiyor = successData.filter(i => i.MESAJ_SABLON_ID === 44).length
    setMusteriyeGidilemiyorSayi(MusteriyeGidilemiyor)
    var MemnuniyetGarantisiArtemis = successData.filter(i => i.MESAJ_SABLON_ID === 55).length
    setMemnuniyetGarantisiArtemisSayi(MemnuniyetGarantisiArtemis)

  }

  const getSmsSablonBasliklar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporSablonBasliklar").then((response) => {
      setSmsSablonBasliklar(response.data)
      setLoadingx(false);
    })
  }

  const getSmsMarkalar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporMarkalar").then((response) => {
      setSmsMarkalar(response.data)
      setLoadingx(false);
    })
  }

  const getSmsKullanicilar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporKullanicilar").then((response) => {
      setSmsKullanicilar(response.data)
      setLoadingx(false);
    })
  }

  function SmsSonuclariniFiltreliAra() {
    debugger
    if (selectedMarkalar.length <= 0 || selectedSmsGonderimDurumlar.length <= 0 || selectedSmsKullanicilar.length <= 0 || selectedSmsSablonBasliklar.length <= 0) {
      setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
      setWarning(true);
      setWarningType("error");
      return;
    }

    var SablonBasliklariList = [];
    selectedSmsSablonBasliklar.map((i) => {
      SablonBasliklariList.push(i.ID);
    })
    var smsRaporMarkalarList = [];
    selectedMarkalar.map((i) => {
      smsRaporMarkalarList.push(i.MARKA_KODU);
    })
    var smsKullanicilarList = [];
    selectedSmsKullanicilar.map((i) => {
      smsKullanicilarList.push(i.KULLANICI_ADI);
    })

    const data = {
      BaslangicTarihi: formattedBaslangicDate,
      BitisTarihi: formattedBitisDate,
      SmsRaporSablonBasliklar: SablonBasliklariList.toString(),
      SmsRaporMarkalar: smsRaporMarkalarList.toString(),
      SmsRaporKullanicilar: smsKullanicilarList.toString(),
      SmsRaporGonderimDurumlar: selectedSmsGonderimDurumlar.value
    }


    setLoadingx(true);
    axios.get(`SmsGonderimTakipRaporuAra/${data.BaslangicTarihi}/${data.BitisTarihi}/${data.SmsRaporSablonBasliklar}/${data.SmsRaporMarkalar}/${data.SmsRaporKullanicilar}/${data.SmsRaporGonderimDurumlar}`)
      .then((response) => {
        var filtreliData = [];
        if (response.data.length > 0) {
          setSmsGeneralData(response.data);
          var data = response.data;
          data.map((i) => {
            if (i.DURUM === 3) {
              filtreliData.push(i);//Gönderilen smsler
            }
          });
          GrafikDataDoldur(filtreliData);
          setLoadingx(false);
        } else {
          setSmsGeneralData([]);
          GrafikDataDoldur(filtreliData);
        }
      })
    setLoadingx(false);
  }

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };
  const handleClick = (reportType) => {
    // Handle click here...
    setReportType(0);
  };
  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loadingx}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Warning}
        autoHideDuration={10000}
        onClose={WarningClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
      </Snackbar>
      <Card>
        <CardHeader
          title="Sms Gönderim Takip Raporu"
          action={
            <IconButton onClick={onClick} style={{ color: 'orange' }}>
              <ArrowBackIcon />
            </IconButton>
          }
        />
        <Divider />
        <Grid container spacing={1}>
          <Grid item xs={3} sm={3} lg={3}>
          </Grid>
          <Grid item xs={6} sm={6} lg={6}>
            <Bar options={options} data={data} />
          </Grid>
          <Grid item xs={3} sm={3} lg={3}>
          </Grid>
        </Grid>
        <br></br>
        <Divider />
        {/* Gönderilen smsler */}
        <Container className={classes.container1} maxWidth="xl">
          <CardContent>
            <Grid container spacing={2} style={{ marginBottom: '0.1rem' }}>
              <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                <Grid item xs={12} sm={6} lg={6}>
                  <Stack direction="row" spacing={1}>
                    <DatePicker
                      label="Başlangıç Tarihi"
                      format="dd.MM.yyyy"
                      value={talepEdilmeBaslangicTarihi}
                      fullWidth
                      onChange={date => {
                        setTalepEdilmeBaslangicTarihi(date);
                      }}
                      renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                    <DatePicker
                      label="Bitiş Tarihi"
                      format="dd.MM.yyyy"
                      value={talepEdilmeBitisTarihi}
                      fullWidth
                      onChange={date => {
                        setTalepEdilmeBitisTarihi(date);
                      }}
                      renderInput={(params) => <TextField fullWidth {...params} />}
                    />
                  </Stack>
                </Grid>
              </LocalizationProvider>
              <Grid item xs={12} sm={6} lg={6} />
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedSmsSablonBasliklar}
                  options={smsSablonBasliklar}
                  getOptionLabel={option => (option.SABLON ? option.SABLON : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsSablonBasliklar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.SABLON}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Şablon Başlıkları"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedMarkalar}
                  options={smsMarkalar}
                  getOptionLabel={option => (option.MARKA_ADI ? option.MARKA_ADI : '')}
                  onChange={(event, newValue) => {
                    setSelectedMarkalar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.MARKA_ADI}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Markalar"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedSmsKullanicilar}
                  options={smsKullanicilar}
                  getOptionLabel={option => (option.KULLANICI_ADI ? option.KULLANICI_ADI : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsKullanicilar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.KULLANICI_ADI}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Kullanıcılar"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  value={selectedSmsGonderimDurumlar}
                  options={smsStatusOptions}
                  getOptionLabel={option => (option.label ? option.label : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsGonderimDurumlar(newValue);
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Sms Gönderim Durumları"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Button
                  className={classes.action}
                  variant="contained"
                  color="primary"
                  fullWidth
                  size='medium'
                  onClick={() => { SmsSonuclariniFiltreliAra(); }}
                >
                  ARA
                  <SearchIcon style={{ marginLeft: '5px' }} />
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} lg={2}>
                <Button
                  className={classes.action}
                  variant="contained"
                  color="primary"
                  fullWidth
                  size='medium'
                  onClick={() => {
                    handleExportClick(1);
                  }}
                >
                  YAZDIR
                  <PrintIcon style={{ marginLeft: '5px' }} />
                </Button>
              </Grid>
              <Divider />
              <Box sx={{ height: 600, width: '100%', marginTop: 1 }}>
                <DataGrid
                  rows={smsGeneralData}
                  columns={columns}
                  getRowId={(row) =>
                    row.ID
                  }
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 100,
                      },
                    },
                  }}
                  components={{ Toolbar: QuickSearchToolbar }}
                  localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
                  pageSizeOptions={[100]}
                />
              </Box>
            </Grid>
          </CardContent>
        </Container>
      </Card>
    </Page >
  );
}

export default SmsTrackingReport;